var map = {
	"./அடக்கமுடைமை.json": [
		534,
		153
	],
	"./அன்புடைமை.json": [
		833,
		833
	],
	"./அருளுடைமை.json": [
		665,
		665
	],
	"./அறன் வலியுறுத்தல்.json": [
		354,
		354
	],
	"./அழுக்காறாமை.json": [
		736,
		736
	],
	"./இனியவை கூறல்.json": [
		504,
		504
	],
	"./இன்னாசெய்யாமை.json": [
		991,
		991
	],
	"./இல்வாழ்க்கை.json": [
		971,
		971
	],
	"./ஈகை.json": [
		321,
		321
	],
	"./ஒப்புரவறிதல்.json": [
		602,
		602
	],
	"./ஒழுக்கமுடைமை.json": [
		70,
		70
	],
	"./கடவுள் வாழ்த்து.json": [
		706,
		706
	],
	"./கள்ளாமை.json": [
		412,
		412
	],
	"./கூடாவொழுக்கம்.json": [
		450,
		450
	],
	"./கொல்லாமை.json": [
		936,
		936
	],
	"./செய்ந்நன்றி அறிதல்.json": [
		729,
		729
	],
	"./தவம்.json": [
		442,
		442
	],
	"./தீவினையச்சம்.json": [
		490,
		490
	],
	"./நடுவு நிலைமை.json": [
		47,
		47
	],
	"./நிலையாமை.json": [
		844,
		844
	],
	"./நீத்தார் பெருமை.json": [
		871,
		871
	],
	"./பயனில சொல்லாமை.json": [
		334,
		334
	],
	"./பிறனில் விழையாமை.json": [
		466,
		466
	],
	"./புகழ்.json": [
		427,
		427
	],
	"./புறங்கூறாமை.json": [
		4,
		4
	],
	"./புலால் மறுத்தல்.json": [
		772,
		772
	],
	"./பொறையுடைமை.json": [
		572,
		572
	],
	"./மக்கட்பேறு.json": [
		178,
		178
	],
	"./வான் சிறப்பு.json": [
		575,
		575
	],
	"./வாய்மை.json": [
		201,
		201
	],
	"./வாழ்க்கைத் துணைநலம்.json": [
		211,
		211
	],
	"./விருந்தோம்பல்.json": [
		651,
		651
	],
	"./வெஃகாமை.json": [
		929,
		929
	],
	"./வெகுளாமை.json": [
		26,
		26
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 741;
module.exports = webpackAsyncContext;